import { createGlobalStyle } from "styled-components";

// Restyles every native switch input (Form.Switch / Control.Switch, used
// wherever ControlInput renders type="switch") to match the same pill +
// sliding-knob look as the FormSwitchRow toggle (formSwitch.styled.ts),
// instead of Bootstrap's default blue switch. Kept as a scoped global style,
// same pattern as ControlDataGridGlobalStyle, since these classes need to
// exist wherever a .control-switch-wrapper is rendered.
export const ControlSwitchGlobalStyle = createGlobalStyle`
.control-switch-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 40px;
    height: 22px;
    flex-shrink: 0;
}

.control-switch-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
}

.control-switch-track {
    position: absolute;
    inset: 0;
    border-radius: 999px;
    border: 1px solid var(--color-grey);
    background: var(--color-grey);
    pointer-events: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.control-switch-track::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--color-white-solid, #ffffff);
    transition: left 0.15s ease;
}

.control-switch-input:checked ~ .control-switch-track {
    background: var(--color-accent-dark);
    border-color: var(--color-accent-dark);
}

.control-switch-input:checked ~ .control-switch-track::after {
    left: 20px;
}

.control-switch-input:disabled ~ .control-switch-track {
    opacity: 0.6;
}

.control-switch-input:focus-visible ~ .control-switch-track {
    box-shadow: var(--shadow-button-focus, 0 0 0px 2px #fff, 0 0 3px 4px rgba(234, 133, 34, 0.5));
}
`;